/** URL に記録されたファイルタブの id。`files` が無く `file` のみの旧形式 URL は 1 タブとして扱う。 */
export function fileTabIdsFromUrl(searchParams: URLSearchParams): string[] {
	return (searchParams.get("files") ?? searchParams.get("file") ?? "").split(",").filter(Boolean);
}
